import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';
import { useClientId } from '../../../../../_hooks/useClientId';
import { queryKeys } from '../../../../api/queryKeys';
import { useFpId } from '../../../../hooks/useFpId';
import { useIsPdf } from '../../../../hooks/useIsPdf';

interface DeleteParams {
  essentialTeamRoleId: string;
}

const deleteEssentialTeamRole = (clientId: number) => ({
  essentialTeamRoleId,
}: DeleteParams) =>
  authFetch('/Consumer/EstatePlanningEssentialRole/DeleteEstatePlanningEssentialTeamRole', {
    method: 'POST',
    ...httpBodyOptions(
      {
        clientId,
        EssentialTeamRoleId: essentialTeamRoleId,
      },
      false,
    ),
  });

export const useDeleteEssentialRoleMutation = () => {
  const queryClient = useQueryClient();
  const clientId = useClientId();
  const fpId = useFpId();
  const isPdf = useIsPdf();

  return useMutation(deleteEssentialTeamRole(clientId), {
    async onSuccess() {
      await queryClient.invalidateQueries(queryKeys.financialPlan(clientId, fpId, isPdf));
    },
  });
};
